<template>
  <div>
    <!-- Overlay -->
    <div v-if="isOpen" class="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" @click="closeSheet"></div>

    <!-- Bottom Sheet -->
    <transition name="slide-up">
      <div v-if="isOpen" class="fixed bottom-0 left-0 right-0 bg-white rounded-t-xl shadow-lg z-[999999999999]"
        :class="`h-${height}`">

        <!-- Header -->
        <div v-if="title" class="flex justify-between items-center mb-4 py-6 border rounded-t-xl border-b-gray-300">
          <h2 class="w-full text-lg font-semibold text-center text-blue">{{ title }}</h2>
          <button @click="closeSheet"
            class="text-blue bg-gray-100 w-8 h-8 flex items-center justify-center text-base rounded-full mr-6">
            ✕
          </button>
        </div>
        <!-- No title just the x button -->
        <div v-else class="w-full flex justify-end pr-4 pt-3" >
          <button @click="closeSheet"
            class="text-blue bg-gray-100 w-6 h-6 flex items-center justify-center text-base rounded-full">
            ✕
          </button>
        </div>


        <!-- Slot for content -->
        <div class="overflow-auto max-h-full p-6 pb-8">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '1/2', // Tailwind height class (e.g., '1/2', '3/4', 'full')
    },
  },
  methods: {
    closeSheet() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
/* Slide-up transition */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease-out;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
